<template>
  <div class="register-container mobile-register">
    <div class="register-card">
      <div class="register-header">
        <h2>教师注册</h2>
      </div>
      
      <el-form :model="registerForm" :rules="registerRules" ref="registerForm" class="register-form">
        <el-form-item prop="nickname" :required="true">
          <el-input v-model="registerForm.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        
        <el-form-item prop="phone">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input v-model="registerForm.password" type="password" placeholder="请输入登录密码" show-password></el-input>
        </el-form-item>
        
        <el-form-item prop="confirmPassword">
          <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入登录密码" show-password></el-input>
        </el-form-item>
        
        <el-form-item prop="email" :required="true">
          <el-input v-model="registerForm.email" placeholder="请输入邮箱（必填）"></el-input>
        </el-form-item>
        
        <!-- 注册验证码（始终显示） -->
        <el-form-item prop="captcha">
          <div class="captcha-container">
            <el-input 
              v-model="registerForm.captcha" 
              placeholder="请输入验证码"
              @keyup.enter.native="handleRegister">
            </el-input>
            <img 
              :src="captchaImage" 
              @click="refreshCaptcha"
              class="captcha-image"
              alt="验证码">
          </div>
          <div class="captcha-hint">
            注册需要验证码以确保账户安全
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleRegister" :loading="loading" class="full-width-btn">注册</el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-link">
        <span>已有账号？</span>
        <el-button type="text" @click="goToLogin">立即登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'SigninMobile',
  data() {
    const validateNickname = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入昵称'))
      } else if (value.length < 2 || value.length > 20) {
        callback(new Error('昵称长度在2到20个字符之间'))
      } else {
        callback()
      }
    }
    
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号格式'))
      } else {
        callback()
      }
    }
    
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6位'))
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'))
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'))
      } else {
        callback()
      }
    }
    
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    
    return {
      loading: false,
      captchaImage: '',
      captchaUuid: '',
      registerForm: {
        nickname: '',
        phone: '',
        password: '',
        confirmPassword: '',
        email: '',
        captcha: ''
      },
      registerRules: {
        nickname: [
          { validator: validateNickname, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        captcha: [
          { validator: validateCaptcha, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 确保注册页面不受任何主题类的影响
    document.body.classList.remove('chinese-theme', 'math-theme', 'english-theme');
    // 添加移动端样式类
    document.body.classList.add('mobile-view');
    // 组件加载时刷新验证码
    this.refreshCaptcha();
  },
  beforeDestroy() {
    // 移除移动端样式类
    document.body.classList.remove('mobile-view');
  },
  methods: {
    // 刷新验证码
    async refreshCaptcha() {
      this.captchaUuid = this.generateUUID();
      try {
        const response = await this.$http.get(`/teachers/captcha-image/${this.captchaUuid}`);
        this.captchaImage = response.data.captcha.image;
      } catch (error) {
        console.error('刷新验证码失败:', error);
        this.$message.error('验证码加载失败');
      }
    },
    
    // 生成UUID
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    
    async handleRegister() {
      try {
        await this.$refs.registerForm.validate()
        this.loading = true
        
        const response = await this.$http.post('/teachers/register', {
          nickname: this.registerForm.nickname,
          phone: this.registerForm.phone,
          password: this.registerForm.password,
          email: this.registerForm.email,
          captchaUuid: this.captchaUuid,
          captchaCode: this.registerForm.captcha,
          deviceType: 'mobile'
        })
        
        if (response.data.success) {
          this.$message.success(response.data.message)
          
          // 保存JWT token、会话ID和用户信息到本地存储
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('sessionId', response.data.sessionId);
          localStorage.setItem('deviceType', 'mobile');
          localStorage.setItem('teacherInfo', JSON.stringify(response.data.teacher))
          
          // 注册成功后跳转到移动端班级选择页面
          this.$router.push('/mobile')
        } else {
          this.$message.error(response.data.message);
          // 注册失败时刷新验证码
          await this.refreshCaptcha();
          this.registerForm.captcha = '';
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败，请重试')
      } finally {
        this.loading = false
      }
    },
    
    goToLogin() {
      this.$router.push('/loginmobile')
    }
  }
}
</script>

<style scoped>
.register-container.mobile-register {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #67C23A, #95d475);
}

.register-card {
  width: 100%;
  max-width: 350px;
  background: white;
  border-radius: 15px;
  padding: 30px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header h2 {
  color: #303133;
  font-size: 24px;
  margin: 0;
  font-weight: bold;
}

.register-form {
  margin-bottom: 20px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  font-size: 14px;
}

.full-width-btn {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
}

.login-link {
  text-align: center;
}

.login-link span {
  color: #909399;
  font-size: 14px;
}

.el-button--text {
  color: #67C23A;
  font-size: 14px;
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .register-container.mobile-register {
    padding: 10px;
  }
  
  .register-card {
    margin: 10px;
    padding: 25px 15px;
  }
  
  .register-header h2 {
    font-size: 22px;
  }
  
  .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
  }
  
  .full-width-btn {
    height: 42px;
    font-size: 15px;
  }
}

/* 验证码样式 */
.captcha-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-container .el-input {
  flex: 1;
}

.captcha-image {
  height: 40px;
  width: 100px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}

.captcha-image:hover {
  border-color: #67C23A;
  transform: scale(1.05);
}

.captcha-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  text-align: left;
}
</style>